<template>
  <div class="nav-user-org-page_nup" :class="{ [curTheme]: true }">
    <div class="page-container_pcr" v-if="activeI > -1">
      <el-dropdown placement="bottom-start">
          <span class="el-dropdown-link">
            {{ links[activeI].text }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(o, i) in links" :key="`link-${i}`"
            :class="{ nup_active: i === activeI }">
            <router-link :to="o.url">
              {{ o.text }}</router-link>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      links: [
        { url: '/user/organization/{orgId}', text: 'Общая статистика' },
        { url: '/user/organization/{orgId}/objects/confirm', text: 'Одобрение новых объектов' },
        { url: '/user/organization/{orgId}/users', text: 'Отчет о действиях пользователей' },
        { url: '/user/organization/{orgId}/users/list', text: 'Работа с пользователями' },
        { url: '/user/organization/{orgId}/objects', text: 'Отчет об операциях с объектами' },
        { url: '/user/organization/{orgId}/deals', text: 'Отчеты по сделкам' },
        { url: '/user/organization/{orgId}/claims', text: 'Работа с жалобами' },
      ],
      activeI: -1,
    };
  },

  created() {
    const orgId = this.$route.params.orgId;
    const path = this.$route.path;
    this.links.forEach((link, i) => {
      this.links[i].url = link.url.replace('{orgId}', orgId);
      if (path === link.url) {
        this.activeI = i;
      }
    });
  },

};
</script>

<style lang="scss">
@import "../../styles/common/main";

.nav-user-org-page_nup {
  padding: 20px 10px;
  margin-bottom: 30px;
  background: rgba(125, 125, 125, .1);
  .el-dropdown-link {
    color: #fff;
    font-size: 15px;
    cursor: default;
  }

  &.theme-w {
    background: rgba(0, 0, 0, .02);
    .el-dropdown-link {
      color: #000;
    }
  }
}

.el-dropdown-menu .nup_active .router-link-exact-active {
  background: lighten($color-1, 10%);
  color: #fff !important;
}

.html_page-form {
  .nav-user-org-page_nup {
    background: rgba(255, 255, 255, .03);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/org-admin/NavUserOrgPage.vue